import React from 'react';
import { Province } from '../types/rwanda';

interface ProvinceSelectorProps {
  provinces: Province[];
  selected: string | null;
  onSelect: (province: string | null) => void;
}

const ProvinceSelector: React.FC<ProvinceSelectorProps> = ({ 
  provinces, 
  selected, 
  onSelect 
}) => {
  return (
    <div className="relative">
      <select 
        value={selected || ''}
        onChange={(e) => onSelect(e.target.value || null)}
        className="bg-white/10 border border-white/20 text-white rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-white/50 min-w-[160px]"
      >
        <option value="" className="text-gray-900">All Rwanda</option>
        {provinces.map(province => (
          <option key={province.name} value={province.name} className="text-gray-900">
            {province.name} Province
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProvinceSelector;